import { state } from './state';
import mutations from './mutations';
import getters from './getters';

const cpfSearched = {
  state,
  mutations,
  getters,
};

export default cpfSearched;
